"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAccountDiscoveryDataForTesting = exports.getOtherAccountAtSameInstitution = exports.getDeadAccountsData = exports.getActiveAccountsData = exports.getUpsertableNewAccountsData = exports.getAccountsBeingMigrated = exports.getInstitutionChannelData = exports.getError = exports.getIsSubmitting = exports.getIsPolling = exports.getIsAccountRefreshingDone = exports.getIsAccountUpsertingDone = exports.getIsAuthenticationDone = exports.getAccountDiscoveryData = exports.getUpdateStrategy = exports.getPublicToken = exports.getPartnerAuthUris = exports.getInstitutionLoginIdBeingMigrated = exports.getMfaChallenge = exports.getInstitutionLogin = exports.getChannel = exports.getInstitution = exports.getInstitutionLoginUpserterDataForScope = exports.getInstitutionLoginUpserterStore = void 0;
const reselect_1 = require("reselect");
const immutable_1 = require("immutable");
const accounts_1 = require("companion-app-components/flux/accounts");
const entitlements_1 = require("companion-app-components/flux/entitlements");
const institutionsUtils_1 = require("companion-app-components/flux/institutions/institutionsUtils");
const selectors_1 = require("data/institutionLogins/selectors");
const buildUpsertableAccountData_1 = __importDefault(require("./buildUpsertableAccountData"));
const types_1 = require("./types");
const transformers = __importStar(require("./transformers"));
const getInstitutionLoginUpserterStore = (state) => state[types_1.REDUCER_KEY];
exports.getInstitutionLoginUpserterStore = getInstitutionLoginUpserterStore;
const getInstitutionLoginUpserterDataForScope = (state, { scope }) => (0, exports.getInstitutionLoginUpserterStore)(state).upserterData.get(scope);
exports.getInstitutionLoginUpserterDataForScope = getInstitutionLoginUpserterDataForScope;
const getInstitution = (state, props) => { var _a; return (_a = (0, exports.getInstitutionLoginUpserterDataForScope)(state, props)) === null || _a === void 0 ? void 0 : _a.institution; };
exports.getInstitution = getInstitution;
const getChannel = (state, props) => { var _a; return (_a = (0, exports.getInstitutionLoginUpserterDataForScope)(state, props)) === null || _a === void 0 ? void 0 : _a.channel; };
exports.getChannel = getChannel;
const getInstitutionLogin = (state, props) => { var _a; return (_a = (0, exports.getInstitutionLoginUpserterDataForScope)(state, props)) === null || _a === void 0 ? void 0 : _a.institutionLogin; };
exports.getInstitutionLogin = getInstitutionLogin;
const getMfaChallenge = (state, props) => { var _a; return (_a = (0, exports.getInstitutionLoginUpserterDataForScope)(state, props)) === null || _a === void 0 ? void 0 : _a.mfaChallenge; };
exports.getMfaChallenge = getMfaChallenge;
const getInstitutionLoginIdBeingMigrated = (state, props) => { var _a; return (_a = (0, exports.getInstitutionLoginUpserterDataForScope)(state, props)) === null || _a === void 0 ? void 0 : _a.institutionLoginIdBeingMigrated; };
exports.getInstitutionLoginIdBeingMigrated = getInstitutionLoginIdBeingMigrated;
const getPartnerAuthUris = (state, props) => { var _a; return (_a = (0, exports.getInstitutionLoginUpserterDataForScope)(state, props)) === null || _a === void 0 ? void 0 : _a.partnerAuthUris; };
exports.getPartnerAuthUris = getPartnerAuthUris;
const getPublicToken = (state, props) => { var _a; return (_a = (0, exports.getInstitutionLoginUpserterDataForScope)(state, props)) === null || _a === void 0 ? void 0 : _a.publicToken; };
exports.getPublicToken = getPublicToken;
const getUpdateStrategy = (state, props) => { var _a; return (_a = (0, exports.getInstitutionLoginUpserterDataForScope)(state, props)) === null || _a === void 0 ? void 0 : _a.updateStrategy; };
exports.getUpdateStrategy = getUpdateStrategy;
const getAccountDiscoveryData = (state, props) => { var _a; return (_a = (0, exports.getInstitutionLoginUpserterDataForScope)(state, props)) === null || _a === void 0 ? void 0 : _a.accountDiscoveryData; };
exports.getAccountDiscoveryData = getAccountDiscoveryData;
const getIsAuthenticationDone = (state, props) => { var _a; return (_a = (0, exports.getInstitutionLoginUpserterDataForScope)(state, props)) === null || _a === void 0 ? void 0 : _a.isAuthenticationDone; };
exports.getIsAuthenticationDone = getIsAuthenticationDone;
const getIsAccountUpsertingDone = (state, props) => { var _a; return (_a = (0, exports.getInstitutionLoginUpserterDataForScope)(state, props)) === null || _a === void 0 ? void 0 : _a.isAccountUpsertingDone; };
exports.getIsAccountUpsertingDone = getIsAccountUpsertingDone;
const getIsAccountRefreshingDone = (state, props) => { var _a; return (_a = (0, exports.getInstitutionLoginUpserterDataForScope)(state, props)) === null || _a === void 0 ? void 0 : _a.isAccountRefreshingDone; };
exports.getIsAccountRefreshingDone = getIsAccountRefreshingDone;
const getIsPolling = (state, props) => { var _a; return (_a = (0, exports.getInstitutionLoginUpserterDataForScope)(state, props)) === null || _a === void 0 ? void 0 : _a.isPolling; };
exports.getIsPolling = getIsPolling;
const getIsSubmitting = (state, props) => { var _a; return (_a = (0, exports.getInstitutionLoginUpserterDataForScope)(state, props)) === null || _a === void 0 ? void 0 : _a.isSubmitting; };
exports.getIsSubmitting = getIsSubmitting;
const getError = (state, props) => { var _a; return (_a = (0, exports.getInstitutionLoginUpserterDataForScope)(state, props)) === null || _a === void 0 ? void 0 : _a.error; };
exports.getError = getError;
exports.getInstitutionChannelData = (0, reselect_1.createSelector)(exports.getInstitution, exports.getChannel, (institution, channel) => {
    var _a;
    if (!institution || !channel) {
        return undefined;
    }
    const aggregatorKey = (_a = (0, institutionsUtils_1.getAggregatorFromChannel)(channel)) === null || _a === void 0 ? void 0 : _a.toLowerCase();
    const aggregatorInfo = institution[aggregatorKey];
    return aggregatorInfo.channelDataByType ? aggregatorInfo.channelDataByType.get(channel) : aggregatorInfo.channelData;
});
exports.getAccountsBeingMigrated = (0, reselect_1.createSelector)(exports.getInstitutionLoginIdBeingMigrated, accounts_1.accountsSelectors.getAccountsByInstitutionLoginId, (institutionLoginId, accountsByInstitutionLoginId) => institutionLoginId ? accountsByInstitutionLoginId.get(institutionLoginId) : null);
exports.getUpsertableNewAccountsData = (0, reselect_1.createSelector)(exports.getAccountDiscoveryData, exports.getAccountsBeingMigrated, selectors_1.getPureManualAccounts, entitlements_1.entitlementsSelectors.getTopTierEntitlement, (accountDiscoveryData, accountsBeingMigrated, pureManualAccounts, tier) => {
    const manualLinkableAccounts = pureManualAccounts.filter((acct) => acct.type !== 'GOAL');
    return (0, buildUpsertableAccountData_1.default)(accountDiscoveryData, accountsBeingMigrated, manualLinkableAccounts, tier);
});
exports.getActiveAccountsData = (0, reselect_1.createSelector)(exports.getAccountDiscoveryData, (accountDiscoveryData) => accountDiscoveryData === null || accountDiscoveryData === void 0 ? void 0 : accountDiscoveryData.activeAccounts);
exports.getDeadAccountsData = (0, reselect_1.createSelector)(exports.getAccountDiscoveryData, (accountDiscoveryData) => accountDiscoveryData === null || accountDiscoveryData === void 0 ? void 0 : accountDiscoveryData.deadAccounts);
exports.getOtherAccountAtSameInstitution = (0, reselect_1.createSelector)(exports.getInstitution, exports.getInstitutionLogin, exports.getInstitutionLoginIdBeingMigrated, selectors_1.getInstitutionLoginsById, accounts_1.accountsSelectors.getAccountsByInstitutionLoginId, (institution, login, loginIdBeingMigrated, loginsById, accountsByLoginId) => {
    const otherLoginsForInstitution = loginsById.reduce((list, iLogin) => {
        if (iLogin.id !== login.id
            && (loginIdBeingMigrated && iLogin.id !== loginIdBeingMigrated)
            && login.institutionId === institution.id) {
            list.push(login);
        }
        return list;
    }, (0, immutable_1.List)());
    return otherLoginsForInstitution.flatMap((loginForInstitution) => {
        const accountsforLoginId = accountsByLoginId.get(loginForInstitution.id);
        return accountsforLoginId
            ? accountsforLoginId.filter((account) => accounts_1.accountsUtils.isActiveConnectedAccount(account))
            : (0, immutable_1.List)();
    });
});
exports.getAccountDiscoveryDataForTesting = (0, reselect_1.createSelector)(() => {
    const data = {
        institutionLoginId: '126817258656712194',
        mode: ' DISCOVER_AND_ADD_ACCOUNTS',
        status: 'OK',
        aggregators: [
            {
                aggStatus: 'DISCOVERED_ACCOUNTS_READY_FOR_USER',
                isProcessing: false,
            },
        ],
        accounts: [
            {
                aggregators: [
                    {
                        channel: 'FDS_SCREEN_SCRAPED',
                        cpId: '2906315190',
                        cpDetails: {
                            type: 'INVESTMENT',
                            subType: 'INVESTMENT_TAXABLE',
                            name: 'My Brokerage',
                            maskedNumber: '0000000000',
                            balance: 805.09,
                            balanceAt: '2018-08-05T07:00:00Z',
                            currency: 'INR',
                            aggStatus: 'OK',
                            cpAggStatusCode: 'success',
                        },
                    },
                ],
            },
            {
                aggregators: [
                    {
                        channel: 'FDS_SCREEN_SCRAPED',
                        cpId: '2906315191',
                        cpDetails: {
                            type: 'LOAN',
                            subType: 'MORTGAGE',
                            name: 'My Mortgage',
                            maskedNumber: '1000000001',
                            balance: 805.09,
                            balanceAt: '2018-08-05T07:00:00Z',
                            currency: 'BND',
                            aggStatus: 'OK',
                            cpAggStatusCode: 'success',
                        },
                    },
                ],
            },
            {
                aggregators: [
                    {
                        channel: 'FDS_SCREEN_SCRAPED',
                        cpId: '2906315193',
                        cpDetails: {
                            type: 'CREDIT',
                            subType: 'CREDIT_CARD',
                            name: 'My Visa',
                            maskedNumber: '4100007777',
                            balance: -805.09,
                            balanceAt: '2018-08-05T07:00:00Z',
                            currency: 'USD',
                            aggStatus: 'OK',
                            cpAggStatusCode: 'success',
                        },
                    },
                ],
            },
            {
                aggregators: [
                    {
                        channel: 'FDS_SCREEN_SCRAPED',
                        cpId: '2906315185',
                        cpDetails: {
                            type: 'BANK',
                            subType: 'CD',
                            name: 'My CD',
                            maskedNumber: '2000005555',
                            balance: 805.09,
                            balanceAt: '2018-08-05T07:00:00Z',
                            currency: 'INR',
                            aggStatus: 'OK',
                            cpAggStatusCode: 'success',
                        },
                    },
                ],
            },
            {
                aggregators: [
                    {
                        channel: 'FDS_SCREEN_SCRAPED',
                        cpId: '2906315186',
                        cpDetails: {
                            type: 'INVESTMENT',
                            subType: 'INVESTMENT_TAXABLE',
                            name: 'My Roth IRA',
                            maskedNumber: '2000004444',
                            balance: 805.09,
                            balanceAt: '2018-08-05T07:00:00Z',
                            currency: 'USD',
                            aggStatus: 'OK',
                            cpAggStatusCode: 'success',
                        },
                    },
                ],
            },
            {
                aggregators: [
                    {
                        channel: 'FDS_SCREEN_SCRAPED',
                        cpId: '2906315189',
                        cpDetails: {
                            type: 'BANK',
                            subType: 'SAVINGS',
                            name: 'My Savings',
                            maskedNumber: '1000002222',
                            balance: 805.09,
                            balanceAt: '2018-08-05T07:00:00Z',
                            currency: 'INR',
                            aggStatus: 'OK',
                            cpAggStatusCode: 'success',
                        },
                    },
                ],
            },
            {
                aggregators: [
                    {
                        channel: 'FDS_SCREEN_SCRAPED',
                        cpId: '2906315192',
                        cpDetails: {
                            type: 'INVESTMENT',
                            subType: 'INVESTMENT_TAX_DEFERRED',
                            name: 'My Retirement',
                            maskedNumber: '0000000001',
                            balance: 805.09,
                            balanceAt: '2018-08-05T07:00:00Z',
                            currency: 'INR',
                            aggStatus: 'OK',
                            cpAggStatusCode: 'success',
                        },
                    },
                ],
            },
            {
                aggregators: [
                    {
                        channel: 'FDS_SCREEN_SCRAPED',
                        cpId: '2906315194',
                        cpDetails: {
                            type: 'BANK',
                            subType: 'CHECKING',
                            name: 'My Checking',
                            maskedNumber: '1000001111',
                            balance: 805.09,
                            balanceAt: '2018-08-05T07:00:00Z',
                            currency: 'BND',
                            aggStatus: 'OK',
                            cpAggStatusCode: 'success',
                        },
                    },
                ],
            },
            {
                aggregators: [
                    {
                        channel: 'FDS_SCREEN_SCRAPED',
                        cpId: '2906315187',
                        cpDetails: {
                            type: 'LOAN',
                            subType: 'LOAN',
                            name: 'My Auto Loan',
                            maskedNumber: '8000008888',
                            balance: 805.09,
                            balanceAt: '2018-08-05T07:00:00Z',
                            currency: 'USD',
                            aggStatus: 'OK',
                            cpAggStatusCode: 'success',
                        },
                    },
                ],
            },
            {
                aggregators: [
                    {
                        channel: 'FDS_SCREEN_SCRAPED',
                        cpId: '2906315188',
                        cpDetails: {
                            type: 'CREDIT',
                            subType: 'LINE_OF_CREDIT',
                            name: 'My Line of Credit',
                            maskedNumber: '8000006666',
                            balance: -805.09,
                            balanceAt: '2018-08-05T07:00:00Z',
                            currency: 'INR',
                            aggStatus: 'OK',
                            cpAggStatusCode: 'success',
                        },
                    },
                ],
            },
        ],
        isProcessing: false,
    };
    return transformers.transformResponseToAccountDiscoveryData(data, (0, immutable_1.Map)());
});
